export default {
  label: {
    series: {
      openTickets: 'Tickets abertos',
      closedTickets: 'Tickets fechados',
    },
  },
};
